module.exports = __webpack_public_path__ + "img/BA.56827754.svg";